import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=53a95405&scoped=true&"
import script from "./QuestionModal.vue?vue&type=script&lang=js&"
export * from "./QuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=53a95405&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a95405",
  null
  
)

export default component.exports